import { Checkbox, Grid, IconButton, Stack, Typography } from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import SaveIcon from "@mui/icons-material/Save";
import { DataGrid } from "@mui/x-data-grid";
import { useDispatch, useSelector } from "react-redux";
import CancelIcon from "@mui/icons-material/Cancel";
import DialogBoxComp from "../../../components/common/DialogBox/DialogBoxComp";
import ScreenCard from "../../../components/common/ScreenCard/ScreenCard";
import TableComp from "../../../components/common/TableComp/TableComp";
import InputWithBtnLayoutComp from "../../../components/InputWithBtnLayout/InputWithBtnLayoutComp";
import InputComp from "../../../components/common/InputComp/Input";
import TabComp from "../../../components/TabsComp/TabComp";
import Btn from "../../../components/common/ButtonComp/Btn";
import { asyncStatus } from "../../../utils/asyncStatus";
import { primaryColor } from "../../../utils/themeColors";
import {
  addOMTermForPrintAsync,
  deleteOMTermForPrintAsync,
  editOMTermForPrintAsync,
  getOMTermForPrintAsync,
} from "../../../store/services/orderManagementService";
const TermForPrint = () => {
  const dispatch = useDispatch();
  const {
    getOMTermForPrintStatus,
    getOMTermForPrintError,
    getOMTermForPrintData,
    addOMTermForPrintStatus,
    addOMTermForPrintData,
    addOMTermForPrintError,

    editOMTermForPrintStatus,
    editOMTermForPrintError,
    editOMTermForPrintData,

    deleteOMTermForPrintData,
    deleteOMTermForPrintStatus,
    deleteOMTermForPrintError,
  } = useSelector((state) => state.om);

  useEffect(() => {
    dispatch(getOMTermForPrintAsync());
  }, []);

  // console.log("getProductStyleData", getProductStyleData);
  const formattedData = getOMTermForPrintData?.length
    ? getOMTermForPrintData.map((style, index) => ({
        id: index + 1, // Assuming the index is a unique identifier for each row
        ...style,
      }))
    : [];
  const [selectedTermForPrint, setSelectedTermForPrint] = useState();
  const [addTermForPrintMode, setAddTermForPrintMode] = useState(false);
  const [addTermForPrintData, setAddTermForPrintData] = useState();
  const [saveDisabled, setSaveDisabled] = useState(true);
  const [editData, setEditData] = useState();
  const [editMode, setEditMode] = useState(false);
  // console.log("selectedTermForPrint", selectedTermForPrint);
  // console.log("editData", editData);
  useEffect(() => {
    if (addOMTermForPrintStatus === asyncStatus.SUCCEEDED) {
      setAddTermForPrintMode(false);
      setSaveDisabled(true);
      setAddTermForPrintData();
    }
  }, [, addOMTermForPrintStatus]);

  const [open, setOpen] = useState(false);
  const agree = () => {
    dispatch(deleteOMTermForPrintAsync(selectedTermForPrint?.term_id));
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    if (deleteOMTermForPrintStatus === asyncStatus.SUCCEEDED || deleteOMTermForPrintStatus === asyncStatus.ERROR ) {
      setOpen(false);
      setSelectedTermForPrint();
    }
  }, [, deleteOMTermForPrintStatus]);
  useEffect(() => {
    if (editOMTermForPrintStatus === asyncStatus.SUCCEEDED) {
      setSelectedTermForPrint();
      setEditMode(false);
      setEditData()
    }
  }, [, editOMTermForPrintStatus]);

  //   const [tableHeight, setTableHeight] = useState("");
  //   let elem = document.getElementById("containerHeight");
  //   useEffect(() => {
  //     console.log("elem?.offsetHeight",elem?.clientHeight);
  //     setTableHeight(elem?.offsetHeight);
  //   }, [ elem?.offsetHeight]);
  // console.log(containerHeight)
  return (
    <Stack padding={2}>
      <DialogBoxComp
        open={open}
        handleClose={handleClose}
        agree={agree}
        innerContent={"Are you sure you want to delete this term for print?"}
        heading={"Delete request"}
      />
      <ScreenCard
        title="Term For Print"
        customHeader={
          <Stack
            sx={{
              padding: 0.5,
              px: 4,
              backgroundColor: primaryColor,
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <Typography sx={{ color: "white", fontWeight: "bold" }}>
              Term For Print
            </Typography>
            <Stack flexDirection={"row"} gap={1}>
              <IconButton
                onClick={() => {
                  setEditMode(false);
                  setAddTermForPrintMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!addTermForPrintMode ? (
                  <AddIcon sx={{ color: "white" }} />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addTermForPrintMode}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  setAddTermForPrintMode(false);
                  setEditMode((prev) => !prev);
                  setSaveDisabled(false);
                }}
              >
                {!editMode ? (
                  <EditIcon />
                ) : (
                  <CancelIcon sx={{ color: "white" }} />
                )}
              </IconButton>
              <IconButton
                disabled={addTermForPrintMode || !selectedTermForPrint}
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => setOpen(true)}
              >
                <DeleteIcon />
              </IconButton>
              <IconButton
                disabled={
                  addOMTermForPrintStatus === asyncStatus.LOADING ||
                  editOMTermForPrintStatus === asyncStatus.LOADING ||
                  saveDisabled
                }
                sx={{ color: "white", ":disabled": { color: "gray" } }}
                onClick={() => {
                  if (addTermForPrintData) {
                    dispatch(addOMTermForPrintAsync(addTermForPrintData));
                  } else if (editMode) {
                    let a;
                    a = { ...selectedTermForPrint, ...editData };
                    delete a.id;
                    dispatch(editOMTermForPrintAsync(a));
                  }
                }}
              >
                <SaveIcon />
              </IconButton>
            </Stack>
          </Stack>
        }
      >
        <Grid container>
          <Grid item xl={3} lg={3} md={3} sm={12} xs={12}>
            <Stack height={500} width={"100%"}>
              <TableComp
                columns={[
                  { field: "term_id", headerName: "ID", flex: true },
                  { field: "term_name", headerName: "Term For Print", flex: true },
                ]}
                onRowClick={(e) => {
                  setSelectedTermForPrint(e?.row);
                }}
                rows={formattedData}
                loading={
                  getOMTermForPrintStatus === asyncStatus.IDLE ||
                  getOMTermForPrintStatus === asyncStatus.LOADING
                }
              />
            </Stack>
          </Grid>
          <Grid item xl={9} lg={9} md={9} sm={12} xs={12} padding={2}>
            {addTermForPrintMode ? (
              <InputWithBtnLayoutComp
              error={addOMTermForPrintError}
                inputArray={[
                  {
                    label: "Term For Print:",
                    comp: (
                      <InputComp
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        onChange={(e) =>
                          setAddTermForPrintData({
                            ...addTermForPrintData,
                            term_name: e.target.value,
                          })
                        }
                      />
                    ),
                  },
                  {
                    label: "Active:",
                    comp: (
                      <Checkbox
                        defaultChecked
                        defaultValue={true}
                        onChange={(e) =>
                          setAddTermForPrintData({
                            ...addTermForPrintData,
                            is_active: e.target.checked,
                          })
                        }
                      />
                    ),
                  },
                ]}
                secondaryComp={<></>}
              />
            ) : selectedTermForPrint ? (
              <InputWithBtnLayoutComp
              error={editOMTermForPrintError}
                inputArray={[
                  {
                    label: "ID:",
                    comp: (
                      <Typography sx={{ fontSize: 14 }}>
                        {selectedTermForPrint?.term_id}
                      </Typography>
                    ),
                  },
                  {
                    label: "TermForPrint:",
                    comp: (
                      <InputComp
                        key={selectedTermForPrint?.term_id} // Add key prop to force remount
                        disabled={!editMode}
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            term_name: e.target.value,
                          })
                        }
                        style={{ borderRadius: 5, fontSize: 12, padding: 4 }}
                        placeholder=""
                        defaultValue={selectedTermForPrint?.term_name}
                      />
                    ),
                  },
                  {
                    label: "Active:",

                    comp: (
                      <Checkbox
                        onChange={(e) =>
                          setEditData({
                            ...editData,
                            is_active: e.target.checked,
                          })
                        }
                        value={selectedTermForPrint?.is_active|| editData?.is_active}
                        disabled={!editMode}
                        // defaultValue={selectedTermForPrint?.is_active || editData?.is_active}
                        defaultChecked={selectedTermForPrint?.is_active || editData?.is_active}
                        // checked={selectedTermForPrint?.is_active}
                      />
                    ),
                  },
                ]}
                secondaryComp={
                  <Btn
                    style={{ fontSize: 10, fontWeight: "bold" }}
                    disabled={editMode}
                  >
                    Assign Companies
                  </Btn>
                }
              />
            ) : (<Stack>
              <Typography>Select any term for print</Typography>
              <Typography color={"red"} fontSize={12}>{getOMTermForPrintError}</Typography>
            </Stack>
            )}
            <Stack my={2}>
              <TabComp
                tabs={[
                  //   {
                  //     name: "Companies",
                  //     content: (
                  //       <Stack height={400} width={"100%"}>
                  //         <TableComp
                  //           columns={[
                  //             {
                  //               field: "companyId",
                  //               headerName: "Company ID",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "companyName",
                  //               headerName: "Company Name",
                  //               flex: true,
                  //             },
                  //             {
                  //               field: "action",
                  //               headerName: "Action",
                  //               flex: true,
                  //             },
                  //           ]}
                  //           //   onRowClick={(e) => {
                  //           //     setSelectedTermForPrint(e?.row);
                  //           //   }}
                  //           rows={[]}
                  //           //   loading={
                  //           //     getProductStyleStatus === asyncStatus.IDLE ||
                  //           //     getProductStyleStatus === asyncStatus.LOADING
                  //           //   }
                  //         />
                  //       </Stack>
                  //     ),
                  //   },
                  {
                    name: "Log Info",
                    content: (
                      <Stack height={400} width={"100%"}>
                        <TableComp
                          columns={[
                            {
                              field: "logId",
                              headerName: "Log ID",
                              flex: true,
                            },
                            {
                              field: "recordId",
                              headerName: "Record_id",
                              flex: true,
                            },
                            {
                              field: "columnName",
                              headerName: "Column Name",
                              flex: true,
                            },
                            {
                              field: "columnValue",
                              headerName: "Column Value",
                              flex: true,
                            },
                            {
                              field: "actionName",
                              headerName: "Action Name",
                              flex: true,
                            },
                            {
                              field: "actionDate",
                              headerName: "Action Date",
                              flex: true,
                            },
                            {
                              field: "userId",
                              headerName: " User ID",
                              flex: true,
                            },
                          ]}
                          //   onRowClick={(e) => {
                          //     setSelectedTermForPrint(e?.row);
                          //   }}
                          rows={[]}
                          //   loading={
                          //     getProductStyleStatus === asyncStatus.IDLE ||
                          //     getProductStyleStatus === asyncStatus.LOADING
                          //   }
                        />
                      </Stack>
                    ),
                  },
                ]}
              />
            </Stack>
          </Grid>
        </Grid>

        {/* <div style={{ height: 400, width: '100%' }}>
      <DataGrid
      sty
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: { page: 0, pageSize: 5 },
          },
        }}
        pageSizeOptions={[5, 10]}
        // checkboxSelection
      />
    </div> */}
      </ScreenCard>
    </Stack>
  );
};

export default TermForPrint;
